export const reduceSetFreshUserKey = (state, { payload: { fresh, key } }) => {
  return {
    ...state,
    user: {
      ...state.user,
      [key]: fresh,
    },
  };
};
